import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Mail, ArrowLeft } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

// 🔐 Connexion P1 : page publique « Mot de passe oublié » — réponse toujours neutre.
export default function MotDePasseOublie() {
  const [email, setEmail] = useState('');
  const [envoye, setEnvoye] = useState(false);
  const [chargement, setChargement] = useState(false);
  const [erreur, setErreur] = useState('');
  const soumettre = async (e) => {
    e.preventDefault();
    setChargement(true); setErreur('');
    try {
      await axios.post(`${API}/api/auth/mot-de-passe-oublie`, { email: email.trim().toLowerCase() });
      setEnvoye(true);
    } catch (err) {
      setErreur('Une erreur est survenue. Réessayez dans quelques instants.');
    } finally { setChargement(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0b1437] p-4" data-testid="page-mot-de-passe-oublie">
      <div className="w-full max-w-md bg-white/5 border border-white/10 rounded-2xl p-8 text-slate-100">
        <h1 className="text-xl font-semibold mb-2">Mot de passe oublié</h1>
        {envoye ? (
          <div className="space-y-4" data-testid="oubli-confirmation">
            <p className="text-sm text-slate-300">Si un compte existe pour ce courriel, un lien de réinitialisation a été envoyé. Vérifiez votre boîte de réception et vos pourriels.</p>
            <Link to="/login" className="text-sm text-blue-300 hover:underline inline-flex items-center gap-1" data-testid="oubli-retour-connexion"><ArrowLeft className="w-4 h-4" /> Retour à la connexion</Link>
          </div>
        ) : (
          <form onSubmit={soumettre} className="space-y-4">
            <p className="text-sm text-slate-300">Entrez votre adresse courriel : nous vous enverrons un lien pour choisir un nouveau mot de passe.</p>
            <div className="relative">
              <Mail className="w-4 h-4 absolute left-3 top-3 text-slate-400" />
              <Input type="text" inputMode="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="votre@courriel.com" className="pl-9 bg-white/10 border-white/20 text-white" data-testid="oubli-email" />
            </div>
            {erreur && <p className="text-sm text-red-300" data-testid="oubli-erreur">{erreur}</p>}
            <Button type="submit" className="w-full" disabled={chargement || !email} data-testid="oubli-envoyer">{chargement ? 'Envoi…' : 'Envoyer le lien'}</Button>
            <Link to="/login" className="text-sm text-blue-300 hover:underline inline-flex items-center gap-1" data-testid="oubli-retour-connexion"><ArrowLeft className="w-4 h-4" /> Retour à la connexion</Link>
          </form>
        )}
      </div>
    </div>
  );
}
